import { shiftDate } from '../../core/format/dates'
import type { Redirect } from '../../core/types/seo'

/**
 * DEMO — doorverwijzingen van de oude WordPress/WooCommerce-site. Eén ervan wijst bewust naar
 * een pagina die niet bestaat, zodat de waarschuwing in Instellingen › Vindbaarheid & pers te zien is.
 */
export const seedRedirects = (today: string): Redirect[] => [
  { from: '/winkel', to: '/webshop', createdAt: shiftDate(today, -40) },
  { from: '/product-categorie/serums', to: '/webshop', createdAt: shiftDate(today, -40) },
  { from: '/blog', to: '/journal', createdAt: shiftDate(today, -40) },
  { from: '/over-mij', to: '/over-ons', createdAt: shiftDate(today, -38) },
  { from: '/afspraak-maken', to: '/behandelingen', createdAt: shiftDate(today, -38) },
  { from: '/zomeractie', to: '/webshop/zomer-set', createdAt: shiftDate(today, -12) },
]
